import getFilterWithCol from '../../helpers/getFilterWithCol';

import { filterStore } from '../../components/common';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { name: { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search category name',
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterPopulateStore = ['FilterHidden', {
  id: 'populateStore',
  build: builder => builder.add('populate', { store: { name: true } }),
}];

export const filterScopeToSellerStore = ['FilterHidden', {
  id: 'scopeToSellerStore',
  build: builder => builder.add('custom', { scopeToSellerStore: true }),
}];

export const filterSort = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  col: 12,
  VALUES_MAP: {
    createdDesc: { createdAt: -1 },
    createdAsc: { createdAt: 1 },
    updatedDesc: { updatedAt: -1 },
    updatedAsc: { updatedAt: 1 },
    nameDesc: { name: 1 },
    nameAsc: { name: -1 },
    productsDesc: { products: -1 },
    productsAsc: { products: 1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
    ? builder.add('sort', { ...filter.VALUES_MAP[value] })
    : builder.add('sort', { ...filter.VALUES_MAP.createdDesc })
  ),
  getValueForField: value => (value && value.length ? value : undefined),
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sort',
    defaultValue: 'createdDesc',
    initialValue: 'createdDesc',
    prepareValueForInput: value => (value ? value : 'createdDesc'),
    choices: [{
      label: '↓ Date Created',
      value: 'createdDesc',
    }, {
      label: '↑ Date Created',
      value: 'createdAsc',
    }, {
      label: '↓ Date Updated',
      value: 'updatedDesc',
    }, {
      label: '↑ Date Updated',
      value: 'updatedAsc',
    }, {
      label: '↓ Name',
      value: 'nameDesc',
    }, {
      label: '↑ Name',
      value: 'nameAsc',
    }, {
      label: '↓ Products',
      value: 'productsDesc',
    }, {
      label: '↑ Products',
      value: 'productsAsc',
    }],
  }],
}];

export const ADMIN = [
  ...[
    [filterSearch, 8],
    [filterStore, 8],
    [filterSort, 8],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateStore,
];

export const SELLER = [
  ...[
    [filterSearch, 12],
    [filterSort, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterPopulateStore,
  filterScopeToSellerStore,
];
